<template>
  <div class="zixun">
     <div class="gaokao">
      <img src="@/assets/gaokao.png" alt="">
     </div>
     <div class="zixuns">
        <div class="zixun01">
           <div class="zixun01s" @click="router(item)" v-for="(item,i) in list" :key="i" v-if="i<5">
 <!--             <div class="ban">
                 <img :src="item.imgurl" alt="" v-if="item.imgurl">
                 <img src="@/assets/gkjypng.png" v-else alt="">
              </div> -->
              <div class="neirong">
                 <div class="title" style="padding-top: 10px;">{{item.title}}</div>
<!--                 <div class="con">
                  {{item.infotion}}
                 </div> -->
                 <div class="time" v-if="item.time">{{timereturn(item.time)}}</div>
              </div>
           </div>
        </div>
        <div class="zixun02">
            <div class="zixun02s">
              <div class="zixun_con" @click="router(item)" v-for="(item,i) in list" v-if="i>5" :key="i">
                  <div class="zixunps">
                     <div class="zixunps01">
                        {{item.title}}
                     </div>
                     <div class="zixunps02" v-if="item.time">
                      {{timereturn(item.time)}}
                     </div>
                  </div>
              </div>
            </div>
        </div>
     </div>
     <div class="more" @click="zixun()">
       更多资讯 >>
     </div>
  </div>
</template>

<script>
 import { InfoMation_index } from "@/api/gw/zonghe"
  export default {
    data(){
      return{
        list:[],
        loading:false
      }
    },
    mounted(){
     this.InfoMation_index();
    },
    methods:{
      //文章详情
      router(item){
        const routerUrl = this.$router.resolve({
              path:"/wenDetail?n=" + item.infomation_id
            })
            window.open(routerUrl.href,"_blank")
      },
      //资讯
      zixun(){
        const routerUrl = this.$router.resolve({
              path:"/zixun"
            })
            window.open(routerUrl.href,"_blank")
      },
      InfoMation_index(){
        this.loading = true
        InfoMation_index({
          page:1,
          limit:12,
          isTuijian:1,
          status:1
        }).then(res=>{
          this.list = res.data.data
        }).finally(()=>{
          this.loading = false
        })
      },
      timereturn(dateTime){
				// 使用split方法以空格为分隔符分割字符串，得到一个数组
				  // 数组的第一个元素是日期部分，第二个元素是时间部分
				  const parts = dateTime.split(' ');
				  // 使用join方法将分割后的数组重新组合成字符串，但只包含日期部分
				  return parts[0];
			},
    },
  }
</script>

<style lang="scss" scoped>
  .more{
    width: 100%;
    text-align: center;
    font-size: 24px;
    cursor: pointer;
    text-decoration: underline;
  }
.zixunps02{
  color: #687382;
  font-size: 16px;
  margin-top: 8px;
  cursor: pointer;
}
.zixun_con{
  width: 100%;
  height: 80px;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 11px;
  .zixunps{
    width: calc(100% - 46px);
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .zixunps01{
      width: 100%;
      font-size: 18px;
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 添加省略号 */
      cursor: pointer;
    }
    .zixunps01:hover,.zixunps02:hover{
      color: #058551;
    }
  }
}
.zixun_con:last-child{
  margin-bottom: 0px;
}
.zixun02s{
  width: 400px;
  height: 528px;
  position: absolute;
  right: 38px;
  top: 38px;
}
.neirong{
  width: 100%;
  position: relative;
  cursor: pointer;
  margin-top: 20px;
  .time{
    color: #687382;
    font-size: 16px;
    margin-top: 10px;
  }
  .con{
    font-size: 18px;
    color: #687382;
    margin-top: 18px;
    line-height: 36px;
    overflow:hidden;

text-overflow:ellipsis;

display:-webkit-box;

-webkit-box-orient:vertical;

-webkit-line-clamp:2;
  }
  .title{
    font-size: 24px;
    font-weight: 400;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 添加省略号 */
  }
  .title:hover,.con:hover,.time:hover{
    color: #058551;
  }
}
  .zixun01s:nth-child(2){

  }
.zixun01s{
  width: calc(100% - 76px);


  margin: 0 auto;
  display: flex;
  .ban{
    width: 280px;
    height: 100px;
    border-radius: 10px;
    background: #ececec;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
}
.zixuns{
  width: 1250px;
  height: 602px;
  margin: 0 auto;
  margin-top: 85px;
  display: flex;
  position: relative;
  .zixun01{
    width: 787px;
    height: 551px;
    background: url("../../../assets/zixun01.png") no-repeat;
    background-size: 100%;
    position: absolute;
    z-index: 2;
    left: 0px;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // flex-direction: column;
  }
  .zixun02{
    width: 556px;
    height: 602px;
    background: url("../../../assets/zixun02.png") no-repeat;
    background-size: 100%;
    position: absolute;
    z-index: 1;
    left: 694px;
  }
}
.zixun{
  width: 100%;
  height: 934px;
  background: #ececec;
  margin-top: 100px;
  background: url("../../../assets/zixunbg.png") no-repeat;
  background-size: 100%;
  .gaokao{
    width: 236px;
    height: 46px;
    margin: 0 auto;
    padding-top: 82px;
    img{
      width: 236px;
      height: 46px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/zixun.vue